export const APM_CLEAN_REIMPORTED_RESPONSE = {
	success: true,
	errors: [
		{
			code: 'MODEL_IS_OVERRIDDEN_AT_BLK',
			message: 'no',
			details: 'The model is imported in BLK'
		},
		{
			code: 'MODEL_IS_MODIFIED_AT_SOURCE',
			message: 'no',
			details: 'The model has been modified at source since its last import'
		},
		{
			code: 'MODEL_IS_A_FIRST_TIME_IMPORT',
			message: 'no',
			details: 'The model is imported for first time '
		}
	],
	status: 'OK',
	response: {
		id: '4a754d63-da68-483c-a4db-ee06e338cb15-apm-clean',
		description: 'APM Clean Reimported',
		type: 'PORTFOLIO',
		subType: 'THIRD_PARTY_MODEL',
		children: [
			{
				identifier: 'IVV@464287200@US4642872000',
				identifierType: 'SECURITY_ID',
				weight: 30,
				allData: {
					date: 1589458144264,
					positionType: 'VALID',
					'@type': '_bws.user.WebUserData',
					description: 'iShares Core S&P 500 ETF',
					identifierType: 'SECURITY_ID',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					dateCreated: 1589458144264,
					dateLastModified: 1589458144264,
					userEmail: 'rrandall@bfm.com',
					commonIdentifier: 'IVV@464287200@US4642872000',
					owner: {
						userPlatformId: '3225081',
						userEmail: 'rrandall@bfm.com',
						userId: 'rrandall@bfm.com'
					},
					identifier: 'IVV@464287200@US4642872000',
					ticker: 'IVV',
					trackingType: 'userData',
					userPlatformId: '3225081',
					childFlag: true,
					level: 1,
					updateUserId: 'rrandall@bfm.com',
					weight: 30,
					userId: 'rrandall@bfm.com',
					updateTimestamp: 1589458144497,
					parentId: '4a754d63-da68-483c-a4db-ee06e338cb15-apm-clean',
					parentType: 'PORTFOLIO',
					commonIdentifierType: 'SECURITY_ID',
					otherIdentifiers: [
						{
							identifier: 'IVV',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						},
						{
							identifier: '464287200',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						},
						{
							identifier: '0100000EOOP01112384HALRLCGAKIKCDGTJB7XPGCQL5ZORZMN2EQCMAA32MZVFA7F4BGKMQ====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						}
					],
					originPlatform: {
						name: 'iShares Core S&P 500',
						type: 'SECURITY'
					},
					userTrackingId: '2555854',
					uniqueId: '3e8b8120-86f8-4410-94ac-15439560e7e4'
				}
			},
			{
				identifier: 'AGG@464287226@US4642872265',
				identifierType: 'SECURITY_ID',
				weight: 40,
				allData: {
					date: 1589458144264,
					positionType: 'VALID',
					'@type': '_bws.user.WebUserData',
					description: 'iShares Core US Aggregate Bond ETF',
					identifierType: 'SECURITY_ID',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					dateCreated: 1589458144264,
					dateLastModified: 1589458144264,
					userEmail: 'rrandall@bfm.com',
					commonIdentifier: 'AGG@464287226@US4642872265',
					owner: {
						userPlatformId: '3225081',
						userEmail: 'rrandall@bfm.com',
						userId: 'rrandall@bfm.com'
					},
					identifier: 'AGG@464287226@US4642872265',
					ticker: 'AGG',
					trackingType: 'userData',
					userPlatformId: '3225081',
					childFlag: true,
					level: 1,
					updateUserId: 'rrandall@bfm.com',
					weight: 40,
					userId: 'rrandall@bfm.com',
					updateTimestamp: 1589458144496,
					parentId: '4a754d63-da68-483c-a4db-ee06e338cb15-apm-clean',
					parentType: 'PORTFOLIO',
					commonIdentifierType: 'SECURITY_ID',
					otherIdentifiers: [
						{
							identifier: '0100000EOOP01114905HLOSJKO4FOOCQVJNCXQQKXFIZQUMDEYRADOFKSBH7USR3A6NVJATA====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: 'AGG',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						},
						{
							identifier: '464287226',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						}
					],
					originPlatform: {
						name: 'iShares Core US Aggregate Bond',
						type: 'SECURITY'
					},
					userTrackingId: '2555854',
					uniqueId: '2229afcc-0ae6-4ea7-9fed-6e67e5ba51f6'
				}
			},
			{
				identifier: 'IJR@464287804@US4642878049',
				identifierType: 'SECURITY_ID',
				weight: 30,
				allData: {
					date: 1575900025096,
					positionType: 'VALID',
					'@type': '_bws.user.WebUserData',
					identifierType: 'SECURITY_ID',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					dateCreated: 1575900063898,
					dateLastModified: 1575900063898,
					userEmail: 'apm6@rockymountainsideweatlh.com',
					commonIdentifier: 'IJR@464287804@US4642878049',
					owner: {
						userPlatformId: '3224231',
						userEmail: 'apm6@rockymountainsideweatlh.com',
						userId: 'apm6@rockymountainsideweatlh.com'
					},
					identifier: 'IJR@464287804@US4642878049',
					trackingType: 'userData',
					userPlatformId: '3224231',
					childFlag: true,
					level: 1,
					updateUserId: 'apm6@rockymountainsideweatlh.com',
					weight: 30,
					userId: 'apm6@rockymountainsideweatlh.com',
					updateTimestamp: 1575900070329,
					parentId: '4a754d63-da68-483c-a4db-ee06e338cb15-apm-clean',
					parentType: 'PORTFOLIO',
					commonIdentifierType: 'SECURITY_ID',
					otherIdentifiers: [
						{
							identifier: '0100000AEEN0115899HGFAVAVZGW3L2TUYQNKT2D4GM4KM6P7P7PUD2BNKMEKNEBYYQPEIQ====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: '464287804',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						},
						{
							identifier: 'IJR',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						}
					],
					originPlatform: {
						name: 'iShares Core S&P Small-Cap',
						type: 'SECURITY'
					},
					userTrackingId: '2555447',
					uniqueId: '383159ef-a789-46e8-bdde-2b7432488a56'
				}
			}
		],
		allData: {
			date: 1589458144264,
			'@type': 'com.bfm.webtools.api.domain.user.WebUserData',
			origin: 'partner',
			flags: {
				originContainsEditableModel: true,
				firstTimeImport: true,
				inputWithValues: false,
				isProcessed: false,
				originSleeveContainsUnmatchedSecurities: false,
				originContainsUnmatchedSecurities: false,
				originContainsSleeves: false
			},
			description: 'APM Dirty with Security',
			type: 'PORTFOLIO',
			currentUserIsOwner: true,
			score: 1,
			parentFlag: true,
			dateCreated: 1589458144264,
			dateLastModified: 1589458144264,
			userEmail: 'rrandall@bfm.com',
			perms: {
				DELETE: [
					'webUserDataPerm@AdvisorPort'
				],
				SHARE: [
					'webUserDataPerm@AdvisorPort'
				],
				VIEW: [
					'webUserDataPerm@AdvisorPort'
				]
			},
			owner: {
				userPlatformId: '3225081',
				userEmail: 'rrandall@bfm.com',
				userId: 'rrandall@bfm.com'
			},
			ssoIdp: 'envestnet',
			toolOrigin: 'partner',
			trackingType: 'userData',
			userPlatformId: '3225081',
			level: 0,
			updateUserId: 'rrandall@bfm.com',
			childCount: 3,
			userId: 'rrandall@bfm.com',
			updateTimestamp: 1589458144497,
			otherIdentifiers: [
				{
					identifier: '4a754d63-da68-483c-a4db-ee06e338cb15-apm-clean',
					customIdentifierType: 'ENVESTNET_HANDLE',
					'@type': '_bws.investments.IdentifierParam',
					identifierType: 'CUSTOM'
				}
			],
			subType: 'THIRD_PARTY_MODEL',
			originPlatform: {
				firm: 'BlackRock',
				dateImported: '1589458144239',
				programHandle: '0100000EEEN01613HTERU5ACK7K7LVH4SCFH27PYMT7DJGMUVG3XAIJDRRANTIEIPDECA====',
				portfolioType: 'ADVISOR_MODEL',
				externalModelDateLastModified: '1589458079723',
				riskHandle: '0100000EOOP03319HHDGRBCT6R5HKSEOM7SVAPCF42QESC7I5246T3UHHCE5X5YGWBATQ====',
				platform: 'ENVESTNET'
			},
			userTrackingId: '2555854',
			uniqueId: '4a754d63-da68-483c-a4db-ee06e338cb15-apm-clean',
			applications: [
				'partner',
				'bfa'
			]
		}
	},
	responseTimes: {
		root: {
			nodes: [
				{
					data: {
						getModelDetails: 1.44
					},
					nodes: [
						{
							data: {
								accessToken: 0.001
							}
						},
						{
							data: {
								searchPortfolio: 0.34
							}
						},
						{
							data: {
								getPortfolioJson: 0.216
							}
						}
					]
				}
			]
		}
	}
};
